import * as React from 'react';

export interface WarningOctagonIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

/**
 * Red warning octagon with a white "!" — the destructive-confirm glyph
 * extracted verbatim from the Noor.Merchant Figma file (node 24:3860). Fixed
 * brand tints (red-500 body, red-400 stroke), so — unlike the monochrome
 * `Menu*Icon` glyphs — it does not follow `currentColor`; callers size it with
 * `size-*` (native frame 64×64).
 */
export function WarningOctagonIcon({ className, ...props }: WarningOctagonIconProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      aria-hidden="true"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.3239 4.12415H41.86C43.058 4.12415 44.1638 4.5849 44.9931 5.41427L58.8159 19.237C59.6452 20.0664 60.106 21.1722 60.106 22.3702V41.8141C60.106 43.0121 59.6452 44.1179 58.8159 44.9473L45.1774 58.5857C44.3481 59.4151 43.2423 59.8758 42.0443 59.8758H22.3239C21.1259 59.8758 20.0201 59.4151 19.1907 58.5857L5.18367 44.5787C4.35431 43.7493 3.89355 42.6435 3.89355 41.4455V22.3702C3.89355 21.1722 4.35431 20.0664 5.18367 19.237L19.0986 5.41427C20.0201 4.5849 21.1259 4.12415 22.3239 4.12415Z"
        fill="#EF4444"
        stroke="#F87171"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M34.291 13.0764L34.3691 13.0891C35.2213 13.2249 36.3171 13.946 36.3174 15.2209V24.469C36.3174 25.0816 36.3185 25.759 36.2168 26.5364L36.2158 26.5471L36.2139 26.5588L35.2002 33.1643L35.1982 33.1741L35.1973 33.1838C35.0232 34.1822 34.1537 34.9807 33.0137 34.9807H30.9863C30.4509 34.9807 29.9587 34.7723 29.5879 34.4739C29.2182 34.1763 28.8992 33.7316 28.8037 33.1838L28.7998 33.1643L27.7861 26.5588V26.5549C27.6811 25.852 27.6826 25.159 27.6826 24.469V15.2209L27.6943 14.9973C27.8134 13.8971 28.7989 13.0764 29.8809 13.0764H34.291Z"
        fill="white"
        stroke="#F87171"
        strokeWidth="2"
      />
      <path
        d="M34.2119 39.6162C35.5013 39.6162 36.5945 40.7087 36.5947 41.998V46.5137C36.5947 47.8032 35.5014 48.8965 34.2119 48.8965H29.6963C28.407 48.8962 27.3145 47.803 27.3145 46.5137V41.998C27.3147 40.7089 28.4071 39.6165 29.6963 39.6162H34.2119Z"
        fill="white"
        stroke="#F87171"
        strokeWidth="2"
      />
    </svg>
  );
}
